{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Свържи отново",
      "FACEBOOK": "Връзката с Facebook е изтекла или е отменена. Съобщенията до страницата не пристигат в тази входяща кутия и отговорите може да не бъдат изпратени. Човек, който управлява страницата във Facebook, трябва да натисне Свържи отново и да влезе във Facebook.",
      "INSTAGRAM": "Връзката с Instagram е изтекла или е отменена. Съобщенията до акаунта не пристигат в тази входяща кутия и отговорите може да не бъдат изпратени. Натиснете Свържи отново и влезте в същия акаунт в Instagram. Друг акаунт създава нова входяща кутия.",
      "GOOGLE": "Връзката с Google е изтекла или е отменена. Новите имейли не пристигат в тази входяща кутия и отговорите може да не бъдат изпратени. Натиснете Свържи отново и влезте в Google като {email}.",
      "MICROSOFT": "Връзката с Microsoft е изтекла или е отменена. Новите имейли не пристигат в тази входяща кутия и отговорите може да не бъдат изпратени. Натиснете Свържи отново и влезте в Microsoft като {email}.",
      "ALLEGRO": "Връзката с Allegro е изтекла или е отменена. Съобщенията от купувачи не пристигат в тази входяща кутия и отговорите може да не бъдат изпратени. Натиснете Свържи отново и влезте в Allegro като продавача {seller}. Друг акаунт на продавач създава нова входяща кутия.",
      "IMAP_LOGIN": "Пощенският сървър отхвърля входа в IMAP като {login}. Новите имейли не стигат до тази кутия. Проверете потребителското име и паролата за IMAP в раздела {tab} и ги запазете. Продължаваме да опитваме да влезем и кутията ще се възстанови веднага щом входът успее.",
      "WHATSAPP": "Връзката с WhatsApp е изтекла или е отменена. Прикачените файлове от клиенти не достигат до тази входяща кутия и отговорите може да не успеят. Щракнете върху Свържи отново, влезте във Facebook и изберете отново номера {phone}."
    },
    "LIST": {
      "404": "There are no inboxes attached to this account.",
      "RECONNECT_REQUIRED": "Нужно е повторно свързване"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Изберете доставчика, който искате да интегрирате с чата."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "You are all set to go!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Вътрешно име",
        "PLACEHOLDER": "Именувайте кутията, както се показва в този дашборд",
        "ERROR": "Моля, въведете уникално вътрешно име"
      },
      "FB": {
        "HELP": "PS: С влизането получаваме достъп само до съобщенията на вашата страница. Никога не можем да получим достъп до личните ви съобщения.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Създай кутия"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Продължи с Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Свържете вашия Instagram профил",
        "HELP": "За да добавите вашия Instagram профил като канал, трябва да удостоверите Instagram профила си чрез натискане на \"Продължи с Instagram\" ",
        "ERROR_MESSAGE": "Възникна грешка при свързване с Instagram, моля опитайте отново",
        "ERROR_AUTH": "Възникна грешка при свързване с Instagram, моля опитайте отново",
        "NEW_INBOX_SUGGESTION": "Този Instagram акаунт преди беше свързан с друга кутия и сега е мигриран тук. Всички нови съобщения ще се появяват тук. Старата кутия повече няма да може да изпраща или получава съобщения за този акаунт.",
        "DUPLICATE_INBOX_BANNER": "Този Instagram акаунт беше мигриран в новата Instagram канална кутия. Повече няма да можете да изпращате/получавате Instagram съобщения от тази кутия."
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website channel",
        "DESC": "Create a channel for your website and start supporting your customers via our website widget.",
        "LOADING_MESSAGE": "Creating Website Support Channel",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Please enter a valid URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website Domain",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welcome Heading",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACEHOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Enabled",
          "DISABLED": "Disabled"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Color",
          "PLACEHOLDER": "Update the widget color used in widget"
        },
        "SUBMIT_BUTTON": "Create inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Please enter your Twilio Account SID",
          "ERROR": "This field is required"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "This field is required"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "This field is required"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "This field is required",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Channel Type",
          "ERROR": "Please select your Channel Type"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "This field is required"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Телефон",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "This field is required"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "This field is required"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "This field is required"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "This field is required"
          },
          "INBOX_NAME": {
            "LABEL": "Име на входящата кутия",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Телефон",
            "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Име на кутията",
            "PLACEHOLDER": "Моля, въведете име на кутията",
            "ERROR": "Това поле е задължително"
          },
          "PHONE_NUMBER": {
            "LABEL": "Телефонен номер",
            "PLACEHOLDER": "Моля, въведете телефонния номер, от който ще се изпращат съобщения.",
            "ERROR": "Моля, предоставете валиден телефонен номер, започващ със знак `+`."
          },
          "SUBMIT_BUTTON": "Създай SMS Brana канал",
          "API": {
            "ERROR_MESSAGE": "Не можахме да създадем SMS Brana канал"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Име на кутията",
            "PLACEHOLDER": "Моля, въведете име на кутията",
            "ERROR": "Това поле е задължително"
          },
          "PHONE_NUMBER": {
            "LABEL": "Телефонен номер",
            "PLACEHOLDER": "Моля, въведете телефонния номер, от който ще се изпращат съобщения.",
            "ERROR": "Моля, предоставете валиден телефонен номер, започващ със знак `+`."
          },
          "SUBMIT_BUTTON": "Създай DIDWW канал",
          "API": {
            "ERROR_MESSAGE": "Не можахме да създадем DIDWW канал"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Бърза настройка с Meta",
          "DESC": "Ще бъдете пренасочени към Meta, за да влезете в своя бизнес акаунт в WhatsApp. Административният достъп ще улесни настройката.",
          "BENEFITS": {
            "EASY_SETUP": "Не се изисква ръчна конфигурация",
            "SECURE_AUTH": "Сигурно удостоверяване чрез OAuth",
            "AUTO_CONFIG": "Автоматична конфигурация на webhook и телефонния номер"
          },
          "SUBMIT_BUTTON": "Свържете се с WhatsApp Business",
          "AUTH_PROCESSING": "Удостоверяване с Meta",
          "WAITING_FOR_BUSINESS_INFO": "Моля, завършете настройката на бизнеса в прозореца на Meta...",
          "PROCESSING": "Настройване на вашия бизнес акаунт в WhatsApp",
          "CANCELLED": "Регистрацията в WhatsApp беше отменена",
          "WAITING_FOR_AUTH": "Изчакване на удостоверяване...",
          "INVALID_BUSINESS_DATA": "Получени са невалидни бизнес данни от Facebook. Моля, опитайте отново.",
          "SIGNUP_ERROR": "Възникна грешка при регистрацията",
          "SDK_LOAD_ERROR": "Facebook SDK не можа да се зареди. Моля, опитайте отново.",
          "AUTH_NOT_COMPLETED": "Удостоверяването не е завършено. Моля, започнете процеса отначало.",
          "SUCCESS_FALLBACK": "Бизнес акаунтът в WhatsApp беше конфигуриран успешно",
          "RECONNECTED": "Каналът WhatsApp е свързан отново успешно"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce канал",
        "DESC": "Интегрирайте със Salesforce канал и започнете да обслужвате клиентите си.",
        "CHANNEL_NAME": {
          "LABEL": "Име на канала",
          "PLACEHOLDER": "Моля, въведете име на канала",
          "ERROR": "Това поле е задължително"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Конфигурирайте базовия URL за вашата Salesforce инстанция.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Това поле е задължително"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID за вашия Salesforce канал.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Това поле е задължително"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret за вашия Salesforce канал.",
          "PLACEHOLDER": "*****",
          "ERROR": "Това поле е задължително"
        },
        "SUBMIT_BUTTON": "Създай Salesforce канал",
        "API": {
          "ERROR_MESSAGE": "Не можахме да запазим Salesforce канала"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Трябва да конфигурирате webhook URL в Salesforce с посочения тук URL."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Използвайте този bearer token за удостоверяване при конфигуриране на webhook в Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Замени имейл подател",
          "SUBTITLE": "Ако е зададен, този имейл адрес ще бъде използван като подател за всички изходящи имейли вместо изходния имейл на разговора.",
          "PLACEHOLDER": "напр. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro канал",
        "DESC": "Свържете акаунт на продавач в Allegro и отговаряйте на центъра му за съобщения от контактния център.",
        "CHANNEL_NAME": {
          "LABEL": "Име на входящата кутия",
          "SUBTITLE": "Името, което агентите виждат за тази кутия.",
          "PLACEHOLDER": "Въведете име на кутията",
          "ERROR": "Това поле е задължително"
        },
        "SUBMIT_BUTTON": "Вход с Allegro",
        "API": {
          "ERROR_MESSAGE": "Възникна грешка при свързването с Allegro, моля опитайте отново"
        },
        "SELLER_LOGIN": {
          "TITLE": "Вход в Allegro",
          "SUBTITLE": "Акаунтът на продавача, за който тази кутия чете и отговаря на съобщения."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland канал",
        "DESC": "Отговаряйте на съобщенията в тикетите, които купувачите ви изпращат в маркетплейса Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Име на канала",
          "PLACEHOLDER": "Моля, въведете име на канала",
          "ERROR": "Това поле е задължително"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32-символният Client Key от страницата с API настройки на вашия акаунт на продавач в Kaufland.",
          "PLACEHOLDER": "ключ от 32 символа",
          "ERROR": "Въведете 32-символния Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64-символният Secret Key, който принадлежи на Client Key. Kaufland го показва веднъж и той никога не се връща на тази страница.",
          "PLACEHOLDER": "ключ от 64 символа",
          "ERROR": "Въведете 64-символния Secret Key"
        },
        "SUBMIT_BUTTON": "Създай Kaufland канал",
        "API": {
          "ERROR_MESSAGE": "Не можахме да запазим Kaufland канала"
        },
        "DISCONNECTED": {
          "TITLE": "Прекъснато",
          "MESSAGE": "Kaufland отхвърли тези API ключове. Въведете отново Client Key и Secret Key, за да свържете отново тази кутия."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Email where your customers sends you support tickets",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Телефонни обаждания",
        "DESC": "Настройте кои телефонни обаждания ще се показват в тази кутия.",
        "NAME": {
          "LABEL": "Име на кутията",
          "SUBTITLE": "Изберете лесно разпознаваемо име."
        },
        "PHONE_NUMBER": {
          "LABEL": "Телефонен номер",
          "SUBTITLE": "Въведете телефонните номера, принадлежащи към тази кутия, може да добавите още номера по-късно.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Създай кутия за телефонни обаждания",
        "API": {
          "ERROR_MESSAGE": "Не можахме да създадем кутията"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Чатът поддържа като канали уиджети за чат на живо, Facebook Messenger, WhatsApp, имейли и др. Ако искате да изградите персонализиран канал, можете да го създадете чрез API канала. За да започнете, изберете един от каналите по-долу."
      },
      "AGENTS": {
        "TITLE": "Агенти",
        "DESC": "Here you can add agents to manage your newly created inbox. Only these selected agents will have access to your inbox. Agents which are not part of this inbox will not be able to see or respond to messages in this inbox when they login. <br> <b>PS:</b> As an administrator, if you need access to all inboxes, you should add yourself as agent to all inboxes that you create.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Inbox Details",
        "DESC": "От падащото меню по-долу изберете Facebook страницата, която искате да свържете с чата. Можете също да дадете персонализирано име на входящата си кутия за по-лесно разпознаване."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "Успешно завършихте интеграцията на вашата Facebook страница с чата. Следващия път, когато клиент изпрати съобщение до страницата ви, разговорът автоматично ще се появи във входящата ви кутия.<br>Предоставяме ви и скрипт за уиджет, който можете лесно да добавите към уебсайта си. Щом той заработи на уебсайта ви, клиентите могат да ви пишат директно от уебсайта ви без помощта на външен инструмент и разговорът ще се появи точно тук, в чата.<br>Страхотно, нали? Е, със сигурност се стараем :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Не можахме да създадем кутията. Моля, опитайте отново.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Configure Inbox Details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Add agents",
      "ADD_AGENTS": "Adding Agents to your Inbox..."
    },
    "FINISH": {
      "TITLE": "Your Inbox is ready!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox."
    },
    "REAUTH": "Reauthorize",
    "VIEW": "View",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox settings updated successfully",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "от",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Включен",
        "DISABLED": "Изключен"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Включен",
        "DISABLED": "Изключен"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Няма"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Включен",
        "DISABLED": "Изключен"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Включено",
        "DISABLED": "Изключено"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Включено",
        "DISABLED": "Изключено"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Enable synchronization of incoming emails"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Enable Custom Email Domain (paid service)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Enable Facebook comments processing"
      },
      "SIGNATURE": {
        "TITLE": "HTML Signature",
        "SUB_TEXT": "This signature will be added to the footer of every message sent from this inbox.",
        "HTML_CONTENT": "HTML code",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} will be replaced with the name of the agent.\n{'{{'}email{'}}'} will be replaced with the email address of the agent who sent the email.\n{'{{'}position{'}}'} will be replaced with the position of the agent.\n{'{{'}custom_line{'}}'} will be replaced with the custom line of the agent.\n{'{{'}email_signature_picture{'}}'} will be replaced with the URL of the agent's email signature picture (not an image tag) — use it as an image source (the src of an img tag).",
        "PREVIEW": "Preview"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Подписи по държава",
        "SUB_TEXT": "Отговорът получава подписа според държавата на купувача.",
        "HELP": "Отговорът се подписва според държавата на разговора: магазина в Kaufland, пазара на поръчката в Allegro, а иначе според езика, на който пише купувачът. Когато държавата е неизвестна или за нея тук няма подпис, се използва HTML подписът по-горе. Пазарите забраняват връзки към вашия уебсайт и данни за контакт, затова оставете само поздрав и {'{{'}name{'}}'}.",
        "EMPTY": "Все още нямате подписи за държави, затова отговорите използват HTML подписа по-горе.",
        "COUNTRY": "Изберете държава",
        "ADD": "Добавяне на подпис за държава",
        "REMOVE": "Премахване"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Phone Number Dialing Prefix",
        "PLACEHOLDER": "Enter prefix for correct call routing (e.g., *99)",
        "HELP_TEXT": "This prefix will be automatically prepended to contact phone numbers when dialing from this inbox."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Текст на бутона „Ще решим по-късно“",
        "PLACEHOLDER": "напр. Ще решим тази тема по имейл. Сега искам да попитам за нещо друго.",
        "HELP_TEXT": "Текст на бутона във уиджета, с който посетителят напуска текущата тема и пита за нещо друго. Ако оставите полето празно, ще се използва текстът по подразбиране на езика на посетителя."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Auto-snooze missed calls for X minutes",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatically snooze missed calls for specified number of minutes. Leave empty or 0 to disable."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Решаване на пропуснато обаждане след X неуспешни обратни обаждания",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Когато на пропуснато обаждане е звънено обратно X пъти без клиентът да отговори, то се решава автоматично и се добавя лична бележка. Оставете празно или 0, за да изключите."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Question Suggestions",
        "SUB_TEXT": "Configure predefined questions that customers can use to interact with your agents.",
        "QUESTIONS_LABEL": "Questions",
        "ADD_QUESTION": "Add Question",
        "QUESTION": "Question",
        "REMOVE": "Remove",
        "QUESTION_TEXT": "Text displayed in the bubble.",
        "QUESTION_TEXT_PLACEHOLDER": "Required",
        "QUESTION_PAYLOAD": "Text sent when clicked.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Optional",
        "SAVE": "Save",
        "NO_BOT_MESSAGE": "To generate additional AI suggestions, please connect a bot.",
        "BOT_CONNECTED_MESSAGE": "AI question suggestions from the bot can be activated in its",
        "BOT_SETTINGS_LINK": "settings"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Алтернативни имейли",
        "SUB_TEXT": "Допълнителни адреси, които тази входяща кутия трябва да третира като свои при получаване на препратена поща.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Добавяне",
        "REMOVE": "Премахване",
        "EMPTY": "Няма конфигурирани алтернативни имейли.",
        "HELP_TEXT": "Когато имейл пристигне с един от тези адреси като получател, отговорите ще се изпращат със същия адрес като подател. Уверете се, че изходящият ви SMTP сървър позволява изпращане от тези адреси.",
        "SIGNATURE_LABEL": "Подпис",
        "PRIMARY_SIGNATURE": "Основен (по подразбиране)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Допълнителни подписи",
        "SUB_TEXT": "Дефинирайте допълнителни подписи тук, след което ги задайте на алтернативните имейли по-долу.",
        "OPTION": "Подпис {number}",
        "ADD": "Добавяне на подпис",
        "REMOVE": "Премахване",
        "HELP_TEXT": "Когато отговор се изпраща от алтернативен имейл, се използва зададеният му подпис вместо подписа на пощенската кутия. Алтернативните имейли, оставени на „Основен (по подразбиране)“, използват подписа на пощенската кутия."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Изтрий",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "This inbox is marked for deletion",
      "RESTORE_BUTTON_TEXT": "Restore",
      "CONFIRM": {
        "TITLE": "Потвърди изтриването",
        "MESSAGE": "Сигурни ли сте за изтриването ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Да, изтрий ",
        "NO": "Не, запази "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "MARKED_FOR_DELETION_MESSAGE": "Inbox marked for deletion",
        "RESTORE_SUCCESS_MESSAGE": "Inbox restored successfully",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "RESTORE_ERROR_MESSAGE": "Could not restore inbox. Please try again later.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Settings",
      "COLLABORATORS": "Collaborators",
      "AUTOMATIC_PRIORITY": "Automatic Priority",
      "AUTOMATIC_LABELING": "Automatic Labeling",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Settings",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Показване на бутона „Започване на нов разговор“ в заглавката на widget-а",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Показване на бутона „Прехвърляне към оператор“ в заглавката на widget-а",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Allow agents to send messages when contact is offline and email continuity is not available",
      "AUTO_CLOSE_OLD": "Mark all past calls from the same number as resolved after one is resolved",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatically assign missed calls when making an outgoing call"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "INBOX_AGENTS": "Агенти",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Cooperators",
      "SELECT_PLACEHOLDER": "Select",
      "AGENTS_OR_TEAMS_INFO": "You can assign either agents or teams - not both simultaneously.",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Enable CSAT on each message",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Enable/Disable CSAT survey option for each message sent by agents",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Отговаряй от имейл",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Имейлите до клиента — както отговорите, така и транскриптите на разговорите — се изпращат чрез SMTP настройките на избраната входяща поща, от избрания адрес (собствения адрес на входящата поща или някой от нейните псевдоними), а отговорите на клиента постъпват обратно през нейния IMAP адрес.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Транскриптите на разговорите се изпращат чрез SMTP настройките на избраната входяща поща, от избрания адрес (собствения адрес на входящата поща или някой от нейните псевдоними), а отговорите постъпват обратно през нейния IMAP адрес.",
      "SHOW_WELCOME_SCREEN": "Show welcome screen",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Show the welcome screen when the widget is opened. If disabled, the widget will go directly to the conversation view.",
      "AUTO_CLOSE_PENDING": "Auto resolve AI chats after (hours)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Auto resolve AI chats after X hours of inactivity.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Смяна на ключа",
        "TITLE": "Смяна на тайния ключ?",
        "WARNING": "Текущият ключ се анулира веднага след смяната му.",
        "WARNING_DETAIL": "Няма преходен период и той не може да бъде възстановен.",
        "IMPACT": "Вашите сървъри трябва да подписват потребителите с новия ключ. Всеки, все още подписан със стария ключ, не преминава проверката. Ако проверката на идентичността е задължителна, той не може да започне разговор.",
        "CONFIRM": "Смяна на ключа",
        "CANCEL": "Отмени",
        "SUCCESS": "Тайният ключ е сменен успешно",
        "ERROR": "Тайният ключ не можа да бъде сменен, моля опитайте отново"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Принудително нов разговор при всяко зареждане на уиджета",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ако е активирано, отварянето на уиджета в нов раздел или прозорец започва нов разговор.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Забравяне на контакта при започване на нов разговор",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ако е деактивирано, нов разговор, започнат от уиджета, запазва предишния контакт.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Email Synchronization",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Enable automatic synchronization and downloading of incoming emails from this inbox",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Custom Email Domain",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Enable to use a custom email domain for outgoing emails",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "You can read more here.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook Comments",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Widget Status",
      "WIDGET_STATUS_ENABLED": "Enabled",
      "WIDGET_STATUS_BUSINESS_HOURS": "Enabled during business hours",
      "WIDGET_STATUS_DISABLED": "Disabled",
      "WIDGET_STATUS_HELP_TEXT": "Control when the widget is shown to visitors on your website",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "CSAT survey and Email Locale",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Choose the language for all customer emails including CSAT surveys, conversation transcripts, and email notifications",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Наследи от акаунта",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Връзка с WhatsApp",
        "SUBTITLE": "Как тази входяща кутия е свързана с WhatsApp.",
        "PROVIDER": "Доставчик",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Свързано чрез вградената регистрация на Meta",
        "STATUS": "Статус",
        "CONNECTED": "Свързано",
        "RECONNECT_HINT": "Натиснете „Свържи отново“ в съобщението по-горе.",
        "PHONE_NUMBER": "Телефонен номер",
        "BUSINESS_ACCOUNT": "ID на WhatsApp Business акаунт",
        "OPEN_MANAGER": "Отвори в WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID на телефонния номер",
        "TEMPLATES": "Шаблони за съобщения",
        "TEMPLATES_COUNT": "{approved} от {total} одобрени",
        "TEMPLATES_SYNCED": "Последна синхронизация: {date}",
        "TEMPLATES_NOT_SYNCED": "Още не са синхронизирани",
        "MANAGE_TEMPLATES": "Управление на шаблони"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "SLA Policies",
      "SUB_TEXT": "Configure SLA response and resolution times for each conversation priority level.",
      "LOADING": "Loading SLA policies...",
      "FIELDS": {
        "ACTIVE": "Active",
        "TICKET_PRIORITY": "Ticket priority",
        "FIRST_RESPONSE_TIME": "First response time",
        "EVERY_RESPONSE_TIME": "Every response time",
        "RESOLUTION_TIME": "Resolution time",
        "PLACEHOLDER": "e.g. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA policies updated successfully.",
        "ERROR_MESSAGE": "Could not update SLA policies. Please try again."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatic Priority",
      "SUB_TEXT": "Configure automatic priority assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every priority evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "ALL_MESSAGES": "On for all inbound messages",
        "FIRST_MESSAGE": "On for first inbound message only"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Priority Level Configuration",
        "SUB_TEXT": "Configure which priority levels should be enabled and their descriptions. Provide clear criteria for AI to determine when this priority should be assigned."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be marked as {priority} priority",
      "SET_AS_DEFAULT": "Set as default priority",
      "MULTIPLE_DEFAULTS_WARNING": "Only one priority level should be set as default. Please uncheck other defaults."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatic Labeling",
      "SUB_TEXT": "Configure automatic label assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every labeling evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "CONVERSATION_OPEN": "On conversation open",
        "CONVERSATION_CLOSE": "On conversation close",
        "ALL_MESSAGES": "On every message - regardless of state",
        "FIRST_MESSAGE": "On first message - regardless of state"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Label Configuration",
        "SUB_TEXT": "Configure which labels should be available for automatic assignment and their descriptions. Provide clear criteria for AI to determine when this label should be applied."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be labeled as {label}. If you leave this empty, the label description will be used.",
      "NO_LABELS_MESSAGE": "No labels found. Create labels first to enable automatic labeling.",
      "CREATE_LABELS_LINK": "Create labels"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reauthorize",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Ключ",
        "TYPE": "Тип",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Save to All Inboxes",
      "SAVE_TO_ALL_TITLE": "Copy Working Hours",
      "SAVE_TO_ALL_CONFIRM": "The settings from this form (availability toggle, out-of-office message, timezone and working hours) will be copied to all other inboxes except email and phone inboxes. Are you sure you want to continue?",
      "SAVE_TO_ALL_CANCEL": "Cancel",
      "SAVE_TO_ALL_YES": "Yes, Copy to All",
      "SAVE_TO_ALL_SUCCESS": "Working hours copied to all other inboxes successfully",
      "SAVE_TO_ALL_ERROR": "Failed to copy working hours to other inboxes"
    },
    "PHONE": {
      "TITLE": "Phone settings",
      "SUBTITLE": "Configure what calls will show up under this inbox.",
      "UPDATE": "Save settings",
      "EDIT": {
        "SUCCESS_MESSAGE": "Phone settings updates",
        "ERROR_MESSAGE": "Failed to update phone settings"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Phone numbers",
        "SUBTITLE": "Enter phone numbers that belong to this inbox.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Add a phone number"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Login",
        "PLACE_HOLDER": "Login"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "PLACE_HOLDER": "Password"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Доставяне на имейли (DNS)",
      "SUB_TITLE": "Всеки работен ден проверяваме SPF, DKIM, DMARC и MX записите на {domain}. Когато нещо кара получаващите сървъри да отхвърлят Вашите отговори или да ги броят за спам, администраторите получават имейл с поправката.",
      "RUN": "Стартиране на проверка",
      "RUN_SUCCESS": "DNS проверката приключи",
      "RUN_ERROR": "DNS проверката не можа да бъде извършена, моля, опитайте отново",
      "NOT_CHECKED": "Все още не е проверявано.",
      "CHECKED_AT": "Последна проверка: {time}.",
      "DNS_UNAVAILABLE": "При последната проверка не получихме отговор от name сървърите на домейна. Резултатът по-долу е от предишната проверка.",
      "SENDER": {
        "SMTP": "Отговорите се изпращат чрез {host}.",
        "PLATFORM": "Отговорите се изпращат чрез нашите пощенски сървъри."
      },
      "STATUS": {
        "OK": "Всички записи са в ред",
        "WARNING": "Някои записи могат да бъдат подобрени",
        "ERROR": "Отговорите може да не стигат до получателите",
        "UNKNOWN": "Неизвестно"
      },
      "SEVERITY": {
        "ERROR": "Проблем",
        "WARNING": "Предупреждение"
      },
      "FIX": "Поправете го със следния DNS запис:",
      "RECORD_TYPE": "Тип",
      "RECORD_HOST": "Име",
      "RECORD_VALUE": "Стойност",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Липсва SPF запис",
          "DESCRIPTION": "Домейнът не посочва кои сървъри могат да изпращат имейли от негово име. Много пощенски сървъри тогава приемат Вашите отговори за спам. Добавете SPF запис, който позволява {sender}."
        },
        "spf_multiple": {
          "TITLE": "Домейнът има {count} SPF записа",
          "DESCRIPTION": "Домейнът може да има само един SPF запис. При повече получаващите сървъри игнорират SPF и често отхвърлят пощата. Обединете ги в един запис."
        },
        "spf_not_authorized": {
          "TITLE": "SPF не позволява сървъра, който изпраща Вашите отговори",
          "DESCRIPTION": "Вашите отговори се изпращат чрез {sender}, но SPF записът на домейна не го включва. Текущ запис: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF записът изисква твърде много DNS заявки",
          "DESCRIPTION": "Получаващите сървъри спират да проверяват SPF след {limit} DNS заявки, но {sender}, който изпраща Вашите отговори, се достига едва след {lookups}. Вашите отговори не минават SPF проверката. Преместете {sender} в началото на записа и премахнете include записите, които домейнът вече не използва."
        },
        "spf_lookups_others": {
          "TITLE": "Някои податели в SPF записа са отвъд лимита на заявките",
          "DESCRIPTION": "SPF записът изисква {lookups} DNS заявки, а получаващите сървъри спират след {limit}. Вашите отговори се разпознават навреме и минават проверката, но пощата от тези податели не минава SPF: {senders}. Премахнете include записите, които домейнът вече не използва."
        },
        "spf_malformed": {
          "TITLE": "SPF записът е повреден",
          "DESCRIPTION": "Получаващите сървъри не могат да прочетат SPF записа на домейна, затова той не защитава Вашите отговори. Проблемът е в: {terms}. Заменете записа с поправения."
        },
        "dkim_missing": {
          "TITLE": "DKIM подписът не е настроен",
          "DESCRIPTION": "Не открихме DKIM ключ на {selectors}. Без него Вашите отговори не са подписани и по-вероятно ще попаднат в спам. Включете DKIM подписването за домейна при Вашия имейл доставчик."
        },
        "dmarc_missing": {
          "TITLE": "Липсва DMARC запис",
          "DESCRIPTION": "Големите пощенски доставчици, като Gmail и Microsoft, очакват DMARC запис. Без него Вашите отговори по-вероятно ще попаднат в спам."
        },
        "dmarc_fails": {
          "TITLE": "DMARC казва на получателите да отхвърлят Вашите отговори",
          "DESCRIPTION": "DMARC политиката на домейна е „{policy}“, а Вашите отговори не минават нито SPF, нито DKIM проверка, затова получателите ги отхвърлят или ги местят в спам. Поправете SPF и DKIM по-горе."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC блокира отговорите, изпращани чрез нашите пощенски сървъри",
          "DESCRIPTION": "Тази пощенска кутия изпраща отговори чрез нашите пощенски сървъри, но DMARC политиката на домейна е „{policy}“, затова получателите ги отхвърлят или ги местят в спам. Настройте SMTP на собствения си пощенски сървър за тази кутия."
        },
        "mx_missing": {
          "TITLE": "Домейнът няма MX запис",
          "DESCRIPTION": "Без MX запис никой не може да изпраща имейли до домейна, затова клиентите не могат да отговарят на Вашите съобщения."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "Възникна грешка, моля опитайте отново"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welcome Heading",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACE_HOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day"
        },
        "WIDGET_COLOR_LABEL": "Widget Color",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Максимална височина на непрочетените съобщения (px)",
          "PLACE_HOLDER": "Без ограничение",
          "HELP_TEXT": "Ограничете максималната височина на прозореца с непрочетени съобщения в пиксели. Оставете празно за поведението по подразбиране (без ограничение)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Чатете с нас",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Чатете с нас"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Обикновено отговаряме до няколко минути",
        "IN_A_FEW_HOURS": "Обикновено отговаряме до няколко часа",
        "IN_A_DAY": "Обикновено отговаряме до един ден"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Започнете разговор",
        "CHAT_INPUT_PLACEHOLDER": "Напишете вашето съобщение"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "В момента не сме на линия"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Осъществено от JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Уебсайт",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Имейл",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "PHONE": "SIP телефон",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
